import {
  FieldType,
  FilterableField,
  NumberField,
  DateField,
  SourceType,
} from 'components/organisms/tasks/fields';

export const useProjectsReportFields = (
  startFieldId: number,
): FilterableField[] => {
  return [
    {
      fieldName: 'startDate',
      fieldLabel: 'Start date - Planned',
      type: FieldType.Date,
    },
    {
      fieldName: 'startingDelay',
      fieldLabel: 'Starting delay',
      type: FieldType.Number,
    },
    {
      fieldName: 'dueDate',
      fieldLabel: 'End date - Planned',
      type: FieldType.Date,
    },
    {
      fieldName: 'endingDelay',
      fieldLabel: 'Ending delay',
      type: FieldType.Number,
    },
  ].map(
    (x, index) =>
      ({
        ...x,
        customField: false,
        private: false,
        fieldId: startFieldId - index,
        sourceType: SourceType.Project,
      } as DateField | NumberField),
  );
};
